// extracted by mini-css-extract-plugin
export default {"slider":"CarouselDisplayStyle_slider__6GYKH"};